export const PARTNER_ROLES = {
  EXTERNAL_SE: 'external_se',
  PAE: 'pae',
  LEADERSHIP: 'leadership',
  ADMIN: 'admin',
};

export const PARTNER_ROLE_LABELS = {
  [PARTNER_ROLES.EXTERNAL_SE]: 'External SE',
  [PARTNER_ROLES.PAE]: 'PAE',
  [PARTNER_ROLES.LEADERSHIP]: 'Leadership',
  [PARTNER_ROLES.ADMIN]: 'Admin',
};

export const PARTNER_PORTAL_ALLOWED_ROLES = new Set(Object.values(PARTNER_ROLES));
